import { ILocationService, IWindowService } from 'angular';
import { PopoverService } from '../../tn.popover/service.tn.popover';
import template from './share-index.html';

export class ShareUrlController {
    static $inject = ['$tnPopover', '$location', '$window'];
    constructor(
        protected $tnPopover: PopoverService,
        protected $location: ILocationService,
        protected $window: IWindowService
    ) {}

    hide(): void {
        this.$tnPopover.hide();
    }
    currentPath(): string {
        return this.$location.absUrl();
    }

    shareOnFacebook(): void {
        this.$window.open(
            `//facebook.com/sharer/sharer.php?u=${this.currentPath()}`,
            'facebook-share-dialog',
            'width=626,height=436'
        );
    }

    shareOnTwitter(): void {
        this.$window.open(
            `//twitter.com/share?url=${this.currentPath()}`,
            'facebook-share-dialog',
            'width=626,height=436'
        );
    }
}

export const shareUrlComponent = {
    controller: ShareUrlController,
    template,
};
